import store from "@/store";

// 判断当前业务是否是pubg
export function isPubg() {
    return store.state.auth.businessId == 1000;
}

// 判断当前业务是否是某个业务
export default function checkBusiness(bId) {
    return store.state.auth.businessId == bId;
}

// 当前业务参数
export function robotConfig() {
    const curRobot = store.state.zhiji.gameState.curRobot;
    return curRobot;
}

// 当前channels
export function robotChannels() {
    const channels = store.state.zhiji.gameState.channels;
    return channels;
}
